export default "__VITE_ASSET__DEuL6Bmh__"